module.exports = __webpack_public_path__ + "static/media/Setting2.a870d81b.png";